import React from "react";
import logoImg from '../../assets/logo_svg.svg'
export const AuthNavbar = ({title = "Create Profile"}) => {
    return (
        <div className="fixed top-0 left-0 right-0 z-10 h-[72px]">
            <div className="flex items-center justify-start py-2 sm:py-4 bg-white w-full px-4 sm:px-[62px]">
                <div className="flex items-center gap-2">
                    <div className="w-10 h-10 overflow-hidden">
                        <img src={logoImg} alt="Logo" className="w-full h-full object-contain" />
                    </div>
                    <div><span className="font-bold text-lable_color text-xl sm:text-2xl font-grotesk">{title}</span></div>
                </div>
            </div>
        </div>
    )
}